<!-- Copyright (c) 2023 Digital Systems (M) Sdn. Bhd. -->
<template>
  <div class="service-code-main">
    <div>
      <Menus :menu="menu" :menuWidth="215" @menuClicked="menuClicked" />
    </div>
    <div class="service-code-table">
      <TableBox :tableData="ServiceCategoryList" :selectedRow.sync="selectedArea" title="Service Code"
        :dataType="columnTypeMain" />
    </div>
    <PopupEntry :show.sync="popupEntryShow" v-if="popupEntryShow" :title="popupEntryTitle" :updatedBy="updatedBy"
      :createdBy="createdBy" @save="saveClicked" :requiredError="entryRequired" :successMessages="entrySuccess"
      :messages="entryMessages" :errorMessages="entryError" @requiredClicked="entryRequiredClicked" :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'">
      <div class="General Details" style="display : flex; height : 100%;">
        <!-- General Details -->
        <div class="gen-details-right" placeholder="Container">
          <!-- ServiceCode -->
          <Input :isDisabled="viewModePK" placeholder="Service Code (max. 10 characters)" :isRequired="true"
            :inputValue.sync="serviceCode" :errorMessage.sync="serviceCodeError" ref="category_serviceCode"
            validator="masterfilecode,10" />
          <!-- ServiceCodeDescription -->
          <Input :isDisabled="viewMode" placeholder="Description (max. 60 characters)" :inputValue.sync="description"
            :isRequired="true" :maxLength="60" :text.sync="description" :errorMessage.sync="descriptionError"
            ref="category_description" validator="text,60,,alphanumeric" />
          <!-- ServiceType -->
          <Dropdown :isDisabled="viewMode" placeholder="Service Type" :selectedObject.sync="serviceType"
            :isRequired="true" :items="ServiceTypeList" itemKey="combinedServiceType" :errorMessage.sync="serviceTypeError"
             ref="serviceType" style="padding-bottom: 30px;" />
          <!-- Type -->
          <Dropdown :isDisabled="viewMode" placeholder="Type" :selectedObject.sync="type" :items="TypeList"
            itemKey="combinedType" :errorMessage.sync="typeError" ref="type"
            style="padding-bottom: 30px;" />
          <!-- Remark -->
          <RemarksBox title="Remarks (max. 200 characters)" :isDisabled="viewMode" :inputValue.sync="remark"
            :maxLength="200" :text.sync="remark" :errorMessage.sync="remarkError" ref="category_remark"
            style="height: 100px" />

        </div>
      </div>
    </PopupEntry>
  </div>
</template>
<script>

export default {
  components: {
  },
  computed: {
  },
  data: function () {
    return {

      menu: [
        { title: 'New Service Code', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png', key: 'MnuNew', visible: true, enabled: true },
        { title: 'Edit Service Code', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png', key: 'MnuEdit', visible: true, enabled: true },
        { title: 'Delete Service Code', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png', key: 'MnuDelete', visible: false, enabled: true }, //api response logic abit weird ("Hide Delete" instead of "Delete")
        { title: 'View Service Code', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png', key: 'MnuQuery', visible: true, enabled: true },
      ],

      ServiceCategoryList: [],
      viewMode: false,
      viewModePK: false,
      popupEntryShow: false,
      menuType: '',
      serviceCode: '', serviceCodeError: '',
      serviceType: null, serviceTypeError: '',
      type: null, typeError: '',
      description: '', descriptionError: '',
      remark: '', remarkError: '',

      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],
      selectedArea: [],
      selectedOriginalArea: null,
      categoryData: [],

      //Service Type
      ServiceTypeList: [],
      //Type
      TypeList: [],

      columnTypeMain: {
        "#": "number",
      },
    };
  },
  props: {
  },
  methods: {
    entryRequiredClicked: function (item) {
      this.$refs[item].setFocus();
    },

    getServiceCategoryList: async function () {
      this.ServiceCategoryList = [];
      this.$fullscreenLoading('Getting Service Code');
      this.ServiceCategoryList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SERVICECODE' });
      this.$fullscreenLoading();
    },

    getDropdownData: async function () {
      this.categoryData = [];
      this.$fullscreenLoading('Getting Service Group');
      this.categoryData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SERVICEGROUP' });
      this.$fullscreenLoading();
    },

    menuClicked: async function (e) {
      this.clearEntryMessages();
      this.clearAllFields();
      
      switch (e.title) {
        case 'New Service Code':
          this.clearAllFields();
          this.getDropdownData();
          this.viewMode = false;
          this.viewModePK = false;
          this.popupEntryShow = true;
          this.descriptionInputIsDisabled = true;
          this.popupEntryTitle = 'New Service Code';
          this.updatedBy = '';
          this.createdBy = '';
          this.menuType = 'New';
          this.serviceType = this.ServiceTypeList[0];
          this.type = this.TypeList[0];
          break;
        case 'Edit Service Code':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No Service Code Selected', 'Please select a service code to edit');
          } else {
            this.viewMode = false;
            this.viewModePK = true;
            this.popupEntryShow = true;
            this.descriptionInputIsDisabled = false;
            this.popupEntryTitle = 'Edit Service Code';
            this.selectedOriginalArea = JSON.parse(JSON.stringify(this.selectedArea[0]));
            await this.populateViewDetails(this.selectedArea[0]['ServiceCode']);
          }
          break;
        case 'Delete Service Code':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No Service Code Selected', 'Please select a service code to delete');
          } else {
            let deleting = await this.$showAlert('warning', 'Delete Service Code', `Are you sure you want to delete Service Code for ${this.selectedArea[0]['ServiceCode']}?`, [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ]);
            if (deleting == 'Delete') {
              let result = await this.$apiCallV2('/ServiceCode/SaveServiceCode', {
                action: 'D',
                servicecode: this.selectedArea[0]['ServiceCode'],
              });
              if (result[0]['Results'] == 0) { // Delete successful
                this.$showAlert('success', 'Service Code Deleted', `Successfully deleted Service Code for ${this.selectedArea[0]['ServiceCode']}`);
                this.$nextTick(async () => await this.getServiceCategoryList());
              } else { // Delete error
                this.$showAlert('error', 'Service Code Not Deleted', `There was an error deleting Service Code for ${this.selectedArea[0]['ServiceCode']}`);
              }
            }
          }
          this.selectedArea = [];
          break;
        case 'View Service Code':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No Service Code Selected', 'Please select a service code to view');
          } else {
            this.viewMode = true;
            this.popupEntryShow = true;
            this.viewModePK = true;
            this.popupEntryTitle = 'View Service Code';
            await this.populateViewDetails(this.selectedArea[0]['ServiceCode']);
          }
          break;
      }
    },
    clearAllFields: function () {
      this.serviceCode = null;
      this.serviceCodeError = '';
      this.serviceType = null;
      this.serviceTypeError = '';
      this.description = '';
      this.descriptionError = '';
      this.remark = '';
      this.remarkError = '';
      this.type = null;
      this.typeError = '';
      this.expenseCode = '';
      this.deptCode = '';
      this.division = '';
      this.menuType = '';
      this.createdBy = '';
      this.updatedBy = '';
    },

    checkFields: function () {
      this.clearEntryMessages();
      if (!this.serviceCode || this.serviceCode.trim() === '') {
        this.serviceCodeError = 'Service Code is required!';
        this.entryRequired.push({ key: 'category_serviceCode', value: 'Service Code is required!' });
      }
      else if (this.serviceCode.length > 10) {
          this.serviceCodeError = 'Service Code cannot exceed 10 characters!';
          this.entryRequired.push({ key: 'category_serviceCode', value: 'Service Code cannot exceed 10 characters!' });
        }
      if (!this.description || this.description.trim() === '') {
        this.descriptionError = 'Service Code Description is required!';
        this.entryRequired.push({ key: 'category_description', value: 'Service Code Description is required!' });
      }
      else if (this.description.length > 60) {
          this.descriptionError = 'Service Code Description cannot exceed 60 characters!';
          this.entryRequired.push({ key: 'category_description', value: "Service Code Description cannot exceed 60 characters!" });
        }
      if (this.remark.length > 200) {
        this.remarkError = 'Remark cannot exceed 200 characters!';
        this.entryRequired.push({ key: 'category_remark', value: "Remark cannot exceed 200 characters!" });
      }
      if (this.serviceType === null) {
        this.serviceTypeError = 'Service type must be Preventive or Repair!';
        this.entryRequired.push({ key: 'serviceType', value: "Service type must be Preventive or Repair!" });
      }
      return this.entryRequired.length > 0;
    },
    clearEntryMessages: function () {
      this.entryRequired = [];
      this.entrySuccess = [];
      this.entryMessages = [];
      this.entryError = [];
    },
    populateTextTrim: function (text) { // To populate text with trim
      return text ? text.trim() : '';
    },
    saveClicked: async function () {
      let isNotValid = this.checkFields();
      if (!isNotValid) {
        let action = this.popupEntryTitle[0];
        if (action == 'E') {
          if (this.selectedOriginalArea['Description'] != this.categoryDescription) {
            let change = await this.$showAlert('warning', 'Edit Service Code', `Are you sure you want to save the data that you had made changes to Service Code: "<b>${this.serviceCode}</b>"`, [
              { text: 'Confirm', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ]);
            if (change == 'Cancel') {
              return;
            }
          }
        }
        let dataToPost = {
          'servicecode': this.serviceCode.toUpperCase().trim(),
          'servicetype': this.serviceType?.['Service Type'],
          'description': this.description.trim(),
          'action': action,//actionflag
          'type': (this.type?.['Service Group']) ?? this.TypeList[0]?.['Service Group'],
          'remark': this.remark,
        };
        this.$fullscreenLoading('Saving Service Code');
        let result = await this.$apiCallV2('/ServiceCode/SaveServiceCode', dataToPost);
        this.$nextTick(async () => await this.getServiceCategoryList());
        this.$fullscreenLoading();
        if (result[0]['Results'] == 0) { // Save successful
          if (action == 'N') {
            this.entrySuccess.push(`Successfully created Service Code: ${this.serviceCode}`);
          } else {
            this.entrySuccess.push(`Successfully edited Service Code: ${this.serviceCode}`);
          }
          this.viewMode = true;
          this.viewModePK = true;
        } else if (action == 'N') { // Save error
           
            this.entryError.push(`There was an error creating Service Code: ${result[0]['ErrMsg']}`);
          } else {
            this.entryError.push(`There was an error editing Service Code: ${result[0]['ErrMsg']}`);
          }
      }
    },
    populateViewDetails: async function (serviceCodeSelected) {
      this.$fullscreenLoading('Getting Details');
      let details = (await this.$apiCallV2('/Master/GetDetailsMaster', { "masterfile": "SERVICECODE", "module": "MASTER", "recordid": serviceCodeSelected, }))["ServiceCode"];
      this.serviceCode = this.populateTextTrim(details['ServiceCode']);
      this.description = this.populateTextTrim(details['Description']);
      this.serviceType = details['ServiceType'] ? this.populateObject(this.ServiceTypeList, 'Service Type', details['ServiceType']) : null;
      this.type = details['Type'] ? this.populateObject(this.TypeList, 'Service Group', details['Type']) : null;
      this.remark = this.populateTextTrim(details['Remark']);
      this.expenseCode = this.populateTextTrim(details['ExpenseCode']);
      this.deptCode = this.populateTextTrim(details['DeptCode']);
      this.division = this.populateTextTrim(details['Division']);
      this.updatedBy = `${details['UserID'].trim() ? details['UserID'].trim() : ''} ${details['DateUpdated'] ? new Date(details['DateUpdated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.createdBy = `${details['UserCreated'] || ''} ${details['TimeCreated'] ? new Date(details['TimeCreated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.$fullscreenLoading();
    },

    populateObject: function (data, key, compare) { // To populate object into dropdown or input query
      try {
        return data.find(d => (d[key]?.trim?.() ?? d[key]) == (compare?.trim?.() ?? compare));
      } catch (error) {
        return null;
      }
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Service Code') {
        x.data.forEach(k => {
          //key in menu same as control value from api
          let selectedMenu = this.menu.find(m => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
          }
        });
      }
    });
  
    const mountedPromises = [];
    let promisesFulfilled = 0;
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SERVICECODE'}).then((result) => {
        this.ServiceCategoryList = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SERVICEGROUP' }).then((result) => {
        this.TypeList = result.map((item) => ({
          ...item,
          combinedType: `${item['Service Group']} - ${item['Description']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SERVICETYPE' }).then((result) => {
        this.ServiceTypeList = result.map((item) => ({
          ...item,
          combinedServiceType: `${item['Service Type']} - ${item['Description']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
  },
  watch: {
  }
};
</script>
<style lang="scss" scoped>
@import '@/css/all.scss';

.service-code-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;

  .service-code-table {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }

  .gen-details-right {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

}
</style>